<div class="file-card-container" [ngClass]="{'tablet': device.isTablet}">
    <div class="file-card-content" (click)="handleContentClick(file, $event)">
        <!-- Image -->
        <ng-container *ngIf="file.type === 'image'">
            <app-smash-image class="thumbnail" [url]="file.thumbnail" type="thumbnail"></app-smash-image>
        </ng-container>

        <!-- Player Audio -->
        <ng-container *ngIf="file.type === 'audio'">
            <ng-container *ngIf="file.previewable">
                <ng-container *ngIf="playerDisplayed; else playerHidden">
                    <div class="player-wrapper" (click)="$event.stopPropagation()">
                        <div class="icon-action"
                            [ngClass]="{'icon-smash_player': !playerIsPlaying, 'icon-smash_pause': playerIsPlaying}"
                            (click)="togglePlay($event)"></div>
                        <app-smash-player #player *ngIf="playerDisplayed" [source]="playerSource"
                            [options]="playerOptions" class="smash-sound-player">
                        </app-smash-player>
                    </div>
                </ng-container>
                <ng-template #playerHidden>
                    <div class="icon-smash_player icon-action"></div>
                </ng-template>
            </ng-container>
        </ng-container>

        <!-- Player Video -->
        <ng-container *ngIf="file.type === 'video'">
            <i class="icon-smash_video icon-action"></i>
        </ng-container>

        <!-- Unknown File Type -->
        <ng-container *ngIf="file.type === 'unknown'">
            <i class="icon-action icon-smash_nopreview"></i>
        </ng-container>
    </div>

    <div class='file-card-footer' [ngClass]="{'selected': fileSelected}">
        <div class="file-informations-full">
            <div class="file-name">{{file.name}}</div>
        </div>
        <div class="file-informations">
            <div class="file-name">{{file.name}}</div>
            <div class="file-size">{{file.size | bytes: 2}} {{ file.ext }}</div>
        </div>
        <div class="file-action">
            <ng-container *ngIf="device.isDesktop; else notDesktop">
                <app-smash-checkbox class="checkbox" [(ngModel)]="fileSelected"
                    (valueChange)="handleFileSelection($event)"></app-smash-checkbox>
            </ng-container>
            <ng-template #notDesktop>
                <div class="icon-download" (click)="$event.stopPropagation()">
                    <a [href]="file.download" target="_blank" (click)="$event.stopPropagation()">
                        <i class="icon-smash_download"></i>
                    </a>
                </div>
            </ng-template>
        </div>
    </div>
</div>